import styled, { css } from 'styled-components';
import { Icon } from '@iconify/react';

type ButtonProps = {
  full?: boolean;
  size: 'xsm' | 'sm' | 'md' | 'lg';
  variant: 'primary' | 'secondary' | 'positive' | 'tertiary' | 'coopercred' | 'danger' | 'dev';
}

export type IconProps = {
  $iconPosition?: 'left' | 'right',
  $hasChildren?: boolean
}

const paddingMap = {
  xsm: { padding: '5px' },
  sm: { padding: '8px' },
  md: { padding: '10px' },
  lg: { padding: '15px' }
};

export const Button = styled.button<ButtonProps>`
  width: ${({ full }) => (full ? '100%' : 'fit-content')};
  
  border-radius: 6px;
  border: none;
  background-color: ${props => props.theme.colors.primary};
  font-weight: 600;
  cursor: pointer;

  display: flex;
  align-items: center;
  justify-content: ${({ full }) => (full ? 'center' : 'space-between')};

  transition: 0.3s;

  ${({ size }) =>
    size &&
    css`
    padding: ${paddingMap[size].padding};
  `}

  ${({ variant, theme }) =>
    variant === 'primary' &&
    css`
      background-color: ${theme.colors.primary};
      color: ${props => props.theme.colors.white};
        &:hover {
          background-color: ${props => props.theme.colors.primary_hover};
        }
    `}

  ${({ variant }) =>
    variant === 'secondary' &&
    css`
      background-color: transparent;
      color: ${props => props.theme.colors.text};
        &:hover {
          background-color: ${props => props.theme.colors.border_grey};
        }
    `}

  ${({ variant }) =>
    variant === 'tertiary' &&
    css`
      background-color:rgb(183, 183, 183);
      color: rgb(48, 48, 48);
        &:hover {
          background-color:rgb(81, 79, 79);
        }
    `}
  ${({ variant }) =>
    variant === 'danger' &&
    css`
      background-color: #fca7a7;
      color: rgb(48, 48, 48);
        &:hover {
          background-color: #f78b8b;
        }
    `}

  ${({ variant }) =>
    variant === 'coopercred' &&
    css`
    background-color: #039639;
    color: ${props => props.theme.colors.white};
      &:hover {
        background-color: #026b29;
      }
  `}

    ${({ variant }) =>
    variant === 'dev' &&
    css`
    background-color: ${props => props.theme.colors.dev};
    color: ${props => props.theme.title};
      &:hover {
        background-color:${props => props.theme.colors.warning};
      }
  `}

    ${({ variant }) =>
    variant === 'positive' &&
    css`
    background-color: ${props => props.theme.colors.positive};
    color: ${props => props.theme.colors.white};
      &:hover {
        background-color:${props => props.theme.colors.positive};
      }
  `}

  padding-inline: 20px;

  &:disabled {
    cursor: not-allowed;
    background-color: #D9D9D9;
    color: ${props => props.theme.colors.grey_text}
  }
`;


export const ButtonIcon = styled(Icon) <IconProps>`
  ${({ $iconPosition, $hasChildren }) =>
    $hasChildren == true && (
      $iconPosition === 'left' ?
        css`
      margin-right: 5px;
    `:
        css`
      margin-left: 5px;
    `)
  }
`;
